module.exports = __webpack_public_path__ + "static/img/3.c239e66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/03/3.png
// module id = e+Jb
// module chunks = 1